import { useMemo } from 'react';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { LOGS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

/**
 * @author Burak Ak
 */
const UpdateErrorLogList = () => {
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	const columns = useMemo(
		() => [
			{
				Header: 'id',
				accessor: 'ID',
				filterType: FilterType.number,
				width: 50,
				show: false,
				showCopyButton: true
			},
			{
				Header: 'orderID',
				accessor: 'orderID',
				filterType: FilterType.string,
				width: 50,
				showOnMobile: true,
				showCopyButton: true
			},
			{
				Header: 'method',
				accessor: 'method',
				filterType: FilterType.multiSelection,
				width: 80,
				showOnMobile: true
			},
			{
				Header: 'url',
				accessor: 'url',
				filterType: FilterType.string,
				width: 100
			},
			{
				Header: 'requestJSON',
				accessor: 'requestJSON',
				filterType: FilterType.string,
				width: 100
			},
			{
				Header: 'updateJSON',
				accessor: 'updateJSON',
				filterType: FilterType.string,
				width: 100,
				show: false,
				showOnMobile: true
			},
			{ Header: 'errorMsg', accessor: 'errorMsg', filterType: FilterType.string, width: 100 },
			{
				Header: 'created_date',
				accessor: 'created_date',
				filterType: FilterType.date,
				width: 80,
				show: true,
				renderCell: ListComponents.DATETIME,
				filterRemovable: false,
				customFilterOptions: [FilterAction.between, FilterAction.on]
			},
			{
				Header: 'nextAttemptTime',
				accessor: 'nextAttemptTime',
				filterType: FilterType.date,
				width: 80,
				show: true,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'attemptCount',
				accessor: 'attemptCount',
				filterType: FilterType.number,
				width: 60
			}
		],
		[]
	);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.UPDATE_ERROR_LOGS}
				columns={columns}
				fetchUrl={LOGS.GET_ECOMMERCE_ERROR_LOGS_LIST}
				defaultSort={defaultSort}
				exportName="updateErrorLogs"
				infiniteScroll
			/>
		</TabTableContainer>
	);
};

export default UpdateErrorLogList;
